/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SurveysIndexRouteImport } from './routes/surveys/index'
import { Route as SetPasswordIndexRouteImport } from './routes/set-password/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as UserActivateUuidIndexRouteImport } from './routes/user-activate/$uuid/index'
import { Route as RouteSurveysAddIndexRouteImport } from './routes/route-surveys/add/index'
import { Route as RouteSurveysUuidIndexRouteImport } from './routes/route-surveys/$uuid/index'
import { Route as ResetPasswordTokenIndexRouteImport } from './routes/reset-password/$token/index'
import { Route as OrganizationsBulkProvisionIndexRouteImport } from './routes/organizations/bulk-provision/index'
import { Route as OrganizationsAddIndexRouteImport } from './routes/organizations/add/index'
import { Route as OrganizationsUuidIndexRouteImport } from './routes/organizations/$uuid/index'
import { Route as IncidentReportsAddIndexRouteImport } from './routes/incident-reports/add/index'
import { Route as IncidentReportsUuidIndexRouteImport } from './routes/incident-reports/$uuid/index'
import { Route as CustomerFeedbacksAddIndexRouteImport } from './routes/customer-feedbacks/add/index'
import { Route as CustomerFeedbacksUuidIndexRouteImport } from './routes/customer-feedbacks/$uuid/index'
import { Route as AccountsAddIndexRouteImport } from './routes/accounts/add/index'
import { Route as AccountsUuidIndexRouteImport } from './routes/accounts/$uuid/index'
import { Route as OrganizationsUuidProfileIndexRouteImport } from './routes/organizations/$uuid/profile/index'
import { Route as OrganizationsUuidEditIndexRouteImport } from './routes/organizations/$uuid/edit/index'
import { Route as AccountsUuidEditIndexRouteImport } from './routes/accounts/$uuid/edit/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysIndexRoute = SurveysIndexRouteImport.update({
  id: '/surveys/',
  path: '/surveys/',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordIndexRoute = SetPasswordIndexRouteImport.update({
  id: '/set-password/',
  path: '/set-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserActivateUuidIndexRoute = UserActivateUuidIndexRouteImport.update({
  id: '/user-activate/$uuid/',
  path: '/user-activate/$uuid/',
  getParentRoute: () => rootRouteImport,
} as any)
const RouteSurveysAddIndexRoute = RouteSurveysAddIndexRouteImport.update({
  id: '/route-surveys/add/',
  path: '/route-surveys/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const RouteSurveysUuidIndexRoute = RouteSurveysUuidIndexRouteImport.update({
  id: '/route-surveys/$uuid/',
  path: '/route-surveys/$uuid/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenIndexRoute = ResetPasswordTokenIndexRouteImport.update({
  id: '/reset-password/$token/',
  path: '/reset-password/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsBulkProvisionIndexRoute =
  OrganizationsBulkProvisionIndexRouteImport.update({
    id: '/organizations/bulk-provision/',
    path: '/organizations/bulk-provision/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsAddIndexRoute = OrganizationsAddIndexRouteImport.update({
  id: '/organizations/add/',
  path: '/organizations/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsUuidIndexRoute = OrganizationsUuidIndexRouteImport.update({
  id: '/organizations/$uuid/',
  path: '/organizations/$uuid/',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentReportsAddIndexRoute = IncidentReportsAddIndexRouteImport.update({
  id: '/incident-reports/add/',
  path: '/incident-reports/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentReportsUuidIndexRoute =
  IncidentReportsUuidIndexRouteImport.update({
    id: '/incident-reports/$uuid/',
    path: '/incident-reports/$uuid/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerFeedbacksAddIndexRoute =
  CustomerFeedbacksAddIndexRouteImport.update({
    id: '/customer-feedbacks/add/',
    path: '/customer-feedbacks/add/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerFeedbacksUuidIndexRoute =
  CustomerFeedbacksUuidIndexRouteImport.update({
    id: '/customer-feedbacks/$uuid/',
    path: '/customer-feedbacks/$uuid/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountsAddIndexRoute = AccountsAddIndexRouteImport.update({
  id: '/accounts/add/',
  path: '/accounts/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsUuidIndexRoute = AccountsUuidIndexRouteImport.update({
  id: '/accounts/$uuid/',
  path: '/accounts/$uuid/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsUuidProfileIndexRoute =
  OrganizationsUuidProfileIndexRouteImport.update({
    id: '/organizations/$uuid/profile/',
    path: '/organizations/$uuid/profile/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsUuidEditIndexRoute =
  OrganizationsUuidEditIndexRouteImport.update({
    id: '/organizations/$uuid/edit/',
    path: '/organizations/$uuid/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountsUuidEditIndexRoute = AccountsUuidEditIndexRouteImport.update({
  id: '/accounts/$uuid/edit/',
  path: '/accounts/$uuid/edit/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/set-password': typeof SetPasswordIndexRoute
  '/surveys': typeof SurveysIndexRoute
  '/accounts/$uuid': typeof AccountsUuidIndexRoute
  '/accounts/add': typeof AccountsAddIndexRoute
  '/customer-feedbacks/$uuid': typeof CustomerFeedbacksUuidIndexRoute
  '/customer-feedbacks/add': typeof CustomerFeedbacksAddIndexRoute
  '/incident-reports/$uuid': typeof IncidentReportsUuidIndexRoute
  '/incident-reports/add': typeof IncidentReportsAddIndexRoute
  '/organizations/$uuid': typeof OrganizationsUuidIndexRoute
  '/organizations/add': typeof OrganizationsAddIndexRoute
  '/organizations/bulk-provision': typeof OrganizationsBulkProvisionIndexRoute
  '/reset-password/$token': typeof ResetPasswordTokenIndexRoute
  '/route-surveys/$uuid': typeof RouteSurveysUuidIndexRoute
  '/route-surveys/add': typeof RouteSurveysAddIndexRoute
  '/user-activate/$uuid': typeof UserActivateUuidIndexRoute
  '/accounts/$uuid/edit': typeof AccountsUuidEditIndexRoute
  '/organizations/$uuid/edit': typeof OrganizationsUuidEditIndexRoute
  '/organizations/$uuid/profile': typeof OrganizationsUuidProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/set-password': typeof SetPasswordIndexRoute
  '/surveys': typeof SurveysIndexRoute
  '/accounts/$uuid': typeof AccountsUuidIndexRoute
  '/accounts/add': typeof AccountsAddIndexRoute
  '/customer-feedbacks/$uuid': typeof CustomerFeedbacksUuidIndexRoute
  '/customer-feedbacks/add': typeof CustomerFeedbacksAddIndexRoute
  '/incident-reports/$uuid': typeof IncidentReportsUuidIndexRoute
  '/incident-reports/add': typeof IncidentReportsAddIndexRoute
  '/organizations/$uuid': typeof OrganizationsUuidIndexRoute
  '/organizations/add': typeof OrganizationsAddIndexRoute
  '/organizations/bulk-provision': typeof OrganizationsBulkProvisionIndexRoute
  '/reset-password/$token': typeof ResetPasswordTokenIndexRoute
  '/route-surveys/$uuid': typeof RouteSurveysUuidIndexRoute
  '/route-surveys/add': typeof RouteSurveysAddIndexRoute
  '/user-activate/$uuid': typeof UserActivateUuidIndexRoute
  '/accounts/$uuid/edit': typeof AccountsUuidEditIndexRoute
  '/organizations/$uuid/edit': typeof OrganizationsUuidEditIndexRoute
  '/organizations/$uuid/profile': typeof OrganizationsUuidProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/set-password/': typeof SetPasswordIndexRoute
  '/surveys/': typeof SurveysIndexRoute
  '/accounts/$uuid/': typeof AccountsUuidIndexRoute
  '/accounts/add/': typeof AccountsAddIndexRoute
  '/customer-feedbacks/$uuid/': typeof CustomerFeedbacksUuidIndexRoute
  '/customer-feedbacks/add/': typeof CustomerFeedbacksAddIndexRoute
  '/incident-reports/$uuid/': typeof IncidentReportsUuidIndexRoute
  '/incident-reports/add/': typeof IncidentReportsAddIndexRoute
  '/organizations/$uuid/': typeof OrganizationsUuidIndexRoute
  '/organizations/add/': typeof OrganizationsAddIndexRoute
  '/organizations/bulk-provision/': typeof OrganizationsBulkProvisionIndexRoute
  '/reset-password/$token/': typeof ResetPasswordTokenIndexRoute
  '/route-surveys/$uuid/': typeof RouteSurveysUuidIndexRoute
  '/route-surveys/add/': typeof RouteSurveysAddIndexRoute
  '/user-activate/$uuid/': typeof UserActivateUuidIndexRoute
  '/accounts/$uuid/edit/': typeof AccountsUuidEditIndexRoute
  '/organizations/$uuid/edit/': typeof OrganizationsUuidEditIndexRoute
  '/organizations/$uuid/profile/': typeof OrganizationsUuidProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/organizations'
    | '/profile'
    | '/set-password'
    | '/surveys'
    | '/accounts/$uuid'
    | '/accounts/add'
    | '/customer-feedbacks/$uuid'
    | '/customer-feedbacks/add'
    | '/incident-reports/$uuid'
    | '/incident-reports/add'
    | '/organizations/$uuid'
    | '/organizations/add'
    | '/organizations/bulk-provision'
    | '/reset-password/$token'
    | '/route-surveys/$uuid'
    | '/route-surveys/add'
    | '/user-activate/$uuid'
    | '/accounts/$uuid/edit'
    | '/organizations/$uuid/edit'
    | '/organizations/$uuid/profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/organizations'
    | '/profile'
    | '/set-password'
    | '/surveys'
    | '/accounts/$uuid'
    | '/accounts/add'
    | '/customer-feedbacks/$uuid'
    | '/customer-feedbacks/add'
    | '/incident-reports/$uuid'
    | '/incident-reports/add'
    | '/organizations/$uuid'
    | '/organizations/add'
    | '/organizations/bulk-provision'
    | '/reset-password/$token'
    | '/route-surveys/$uuid'
    | '/route-surveys/add'
    | '/user-activate/$uuid'
    | '/accounts/$uuid/edit'
    | '/organizations/$uuid/edit'
    | '/organizations/$uuid/profile'
  id:
    | '__root__'
    | '/'
    | '/dashboard/'
    | '/forgot-password/'
    | '/login/'
    | '/organizations/'
    | '/profile/'
    | '/set-password/'
    | '/surveys/'
    | '/accounts/$uuid/'
    | '/accounts/add/'
    | '/customer-feedbacks/$uuid/'
    | '/customer-feedbacks/add/'
    | '/incident-reports/$uuid/'
    | '/incident-reports/add/'
    | '/organizations/$uuid/'
    | '/organizations/add/'
    | '/organizations/bulk-provision/'
    | '/reset-password/$token/'
    | '/route-surveys/$uuid/'
    | '/route-surveys/add/'
    | '/user-activate/$uuid/'
    | '/accounts/$uuid/edit/'
    | '/organizations/$uuid/edit/'
    | '/organizations/$uuid/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  SetPasswordIndexRoute: typeof SetPasswordIndexRoute
  SurveysIndexRoute: typeof SurveysIndexRoute
  AccountsUuidIndexRoute: typeof AccountsUuidIndexRoute
  AccountsAddIndexRoute: typeof AccountsAddIndexRoute
  CustomerFeedbacksUuidIndexRoute: typeof CustomerFeedbacksUuidIndexRoute
  CustomerFeedbacksAddIndexRoute: typeof CustomerFeedbacksAddIndexRoute
  IncidentReportsUuidIndexRoute: typeof IncidentReportsUuidIndexRoute
  IncidentReportsAddIndexRoute: typeof IncidentReportsAddIndexRoute
  OrganizationsUuidIndexRoute: typeof OrganizationsUuidIndexRoute
  OrganizationsAddIndexRoute: typeof OrganizationsAddIndexRoute
  OrganizationsBulkProvisionIndexRoute: typeof OrganizationsBulkProvisionIndexRoute
  ResetPasswordTokenIndexRoute: typeof ResetPasswordTokenIndexRoute
  RouteSurveysUuidIndexRoute: typeof RouteSurveysUuidIndexRoute
  RouteSurveysAddIndexRoute: typeof RouteSurveysAddIndexRoute
  UserActivateUuidIndexRoute: typeof UserActivateUuidIndexRoute
  AccountsUuidEditIndexRoute: typeof AccountsUuidEditIndexRoute
  OrganizationsUuidEditIndexRoute: typeof OrganizationsUuidEditIndexRoute
  OrganizationsUuidProfileIndexRoute: typeof OrganizationsUuidProfileIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys/': {
      id: '/surveys/'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof SurveysIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password/': {
      id: '/set-password/'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-activate/$uuid/': {
      id: '/user-activate/$uuid/'
      path: '/user-activate/$uuid'
      fullPath: '/user-activate/$uuid'
      preLoaderRoute: typeof UserActivateUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/route-surveys/add/': {
      id: '/route-surveys/add/'
      path: '/route-surveys/add'
      fullPath: '/route-surveys/add'
      preLoaderRoute: typeof RouteSurveysAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/route-surveys/$uuid/': {
      id: '/route-surveys/$uuid/'
      path: '/route-surveys/$uuid'
      fullPath: '/route-surveys/$uuid'
      preLoaderRoute: typeof RouteSurveysUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token/': {
      id: '/reset-password/$token/'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/bulk-provision/': {
      id: '/organizations/bulk-provision/'
      path: '/organizations/bulk-provision'
      fullPath: '/organizations/bulk-provision'
      preLoaderRoute: typeof OrganizationsBulkProvisionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/add/': {
      id: '/organizations/add/'
      path: '/organizations/add'
      fullPath: '/organizations/add'
      preLoaderRoute: typeof OrganizationsAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$uuid/': {
      id: '/organizations/$uuid/'
      path: '/organizations/$uuid'
      fullPath: '/organizations/$uuid'
      preLoaderRoute: typeof OrganizationsUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incident-reports/add/': {
      id: '/incident-reports/add/'
      path: '/incident-reports/add'
      fullPath: '/incident-reports/add'
      preLoaderRoute: typeof IncidentReportsAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incident-reports/$uuid/': {
      id: '/incident-reports/$uuid/'
      path: '/incident-reports/$uuid'
      fullPath: '/incident-reports/$uuid'
      preLoaderRoute: typeof IncidentReportsUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-feedbacks/add/': {
      id: '/customer-feedbacks/add/'
      path: '/customer-feedbacks/add'
      fullPath: '/customer-feedbacks/add'
      preLoaderRoute: typeof CustomerFeedbacksAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-feedbacks/$uuid/': {
      id: '/customer-feedbacks/$uuid/'
      path: '/customer-feedbacks/$uuid'
      fullPath: '/customer-feedbacks/$uuid'
      preLoaderRoute: typeof CustomerFeedbacksUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/add/': {
      id: '/accounts/add/'
      path: '/accounts/add'
      fullPath: '/accounts/add'
      preLoaderRoute: typeof AccountsAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$uuid/': {
      id: '/accounts/$uuid/'
      path: '/accounts/$uuid'
      fullPath: '/accounts/$uuid'
      preLoaderRoute: typeof AccountsUuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$uuid/profile/': {
      id: '/organizations/$uuid/profile/'
      path: '/organizations/$uuid/profile'
      fullPath: '/organizations/$uuid/profile'
      preLoaderRoute: typeof OrganizationsUuidProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$uuid/edit/': {
      id: '/organizations/$uuid/edit/'
      path: '/organizations/$uuid/edit'
      fullPath: '/organizations/$uuid/edit'
      preLoaderRoute: typeof OrganizationsUuidEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$uuid/edit/': {
      id: '/accounts/$uuid/edit/'
      path: '/accounts/$uuid/edit'
      fullPath: '/accounts/$uuid/edit'
      preLoaderRoute: typeof AccountsUuidEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  SetPasswordIndexRoute: SetPasswordIndexRoute,
  SurveysIndexRoute: SurveysIndexRoute,
  AccountsUuidIndexRoute: AccountsUuidIndexRoute,
  AccountsAddIndexRoute: AccountsAddIndexRoute,
  CustomerFeedbacksUuidIndexRoute: CustomerFeedbacksUuidIndexRoute,
  CustomerFeedbacksAddIndexRoute: CustomerFeedbacksAddIndexRoute,
  IncidentReportsUuidIndexRoute: IncidentReportsUuidIndexRoute,
  IncidentReportsAddIndexRoute: IncidentReportsAddIndexRoute,
  OrganizationsUuidIndexRoute: OrganizationsUuidIndexRoute,
  OrganizationsAddIndexRoute: OrganizationsAddIndexRoute,
  OrganizationsBulkProvisionIndexRoute: OrganizationsBulkProvisionIndexRoute,
  ResetPasswordTokenIndexRoute: ResetPasswordTokenIndexRoute,
  RouteSurveysUuidIndexRoute: RouteSurveysUuidIndexRoute,
  RouteSurveysAddIndexRoute: RouteSurveysAddIndexRoute,
  UserActivateUuidIndexRoute: UserActivateUuidIndexRoute,
  AccountsUuidEditIndexRoute: AccountsUuidEditIndexRoute,
  OrganizationsUuidEditIndexRoute: OrganizationsUuidEditIndexRoute,
  OrganizationsUuidProfileIndexRoute: OrganizationsUuidProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
